import { TRANSACTIONS, TRANS_IMPORT } from '@/transaction'
import { registerRoute } from '@/router'
import { useBreadCrumbs } from '@/breadcrumbs/useBreadCrumbs'
import { usePanelManager } from '@tritt/multipanel'
import { h } from 'vue'
import TransactionCrumb from '@/transaction/TransactionCrumb.vue'
import { useContaCommand } from '@/commandbar/commandBar.service'
import { NavGroup, registerNavigationEntry } from '@/navigation'

const { buildSimpleCrumb, registerBreadCrumbGetter } = useBreadCrumbs()
const { registerNavigationCommand } = useContaCommand()

// Transactions
registerRoute(TRANSACTIONS)
registerBreadCrumbGetter(() => {
    const { currentPanelContent } = usePanelManager()
    if (currentPanelContent.value?.componentName !== TRANSACTIONS.componentName) {
        return
    }
    return h(TransactionCrumb, {
        transactionUuid: currentPanelContent.value?.props.transactionUuid,
    })
})

// Transaction Import
registerRoute(TRANS_IMPORT)
const label = 'Importere bilag'
const icon = 'i-ph-file-plus'
registerNavigationCommand({
    route: TRANS_IMPORT,
    label,
    icon
})
registerNavigationEntry(NavGroup.IMPORTS, {
    title: label,
    target: TRANS_IMPORT,
    key: 'transaction-import',
    icon,
    sortOrder: 1
})
buildSimpleCrumb(TRANS_IMPORT, label, icon)
